import { objectWithoutPropertiesLoose as _objectWithoutPropertiesLoose, extends as _extends } from '../../_virtual/_rollupPluginBabelHelpers.js';
import React__default from 'react';
import { __DEV__ } from '../../utils/assertion.esm.js';
import '../../utils/ssr.esm.js';
import '../../utils/number.esm.js';
import '../../utils/array.esm.js';
import '../../utils/breakpoint.esm.js';
import '../../utils/context.esm.js';
import '../../utils/dom.esm.js';
import '../../utils/tabbable.esm.js';
import '../../utils/dom-query.esm.js';
import '../../utils/logger.esm.js';
import '../../utils/focus.esm.js';
import '../../utils/function.esm.js';
import '../../utils/keydown.esm.js';
import '../../utils/lazy.esm.js';
import '../../utils/object.esm.js';
import '../../utils/react-helpers.esm.js';
import '../../utils/style-props.esm.js';
import '../../utils/tailwind.esm.js';
export { default as DrawerCloseButton } from '../Modal/ModalCloseButton/index.esm.js';
export { default as DrawerFooter } from '../Modal/ModalFooter/index.esm.js';
export { default as DrawerHeader } from '../Modal/ModalHeader/index.esm.js';
export { default as DrawerTitle } from '../Modal/ModalTitle/index.esm.js';
import Modal from '../Modal/index.esm.js';
import DrawerContext from './context.esm.js';
export { default as DrawerBody } from './DrawerBody/index.esm.js';
export { default as DrawerContent } from './DrawerContent/index.esm.js';
export { default as DrawerOverlay } from './DrawerOverlay/index.esm.js';

var Drawer = function Drawer(props) {
  var open = props.open,
      onClose = props.onClose,
      _props$placement = props.placement,
      placement = _props$placement === void 0 ? 'right' : _props$placement,
      finalFocusRef = props.finalFocusRef,
      _props$size = props.size,
      size = _props$size === void 0 ? 'max-w-sm' : _props$size,
      rest = _objectWithoutPropertiesLoose(props, ["open", "onClose", "fullHeight", "placement", "finalFocusRef", "size"]);

  return React__default.createElement(DrawerContext.Provider, {
    value: {
      placement: placement
    }
  }, React__default.createElement(Modal, _extends({
    open: open,
    size: size,
    onClose: onClose,
    finalFocusRef: finalFocusRef
  }, rest)));
};

if (__DEV__) {
  Drawer.displayName = 'Drawer';
}

export default Drawer;
//# sourceMappingURL=index.esm.js.map
